import gql from 'graphql-tag'

export const ChatPromptTranslateFragment = gql`
  fragment ChatPromptTranslateFragment on ChatPromptTranslate {
    id
    ngChatPrompt
    ngChatPromptCategory
    ngChatPromptCategoryId
    ngCreatedBy
    ngCreatedOn
    ngDeleted
    ngLanguage
    ngModifiedBy
    ngModifiedOn
    ngPublished
    ngSequence
    ngTransferTimestamp
    pform
    pid
    system
    userid
  }
`
